import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { Data_Expiration_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Data_Expiration_CCP.interface';
import { Filter_Check_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Filter_Check_CCP.interface';
import { Headers_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Headers-CCP.interface';
import { LIBRARYCCPService } from 'src/app/Services/Libraries/General-CCP/library-ccp.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-document-expire-ccp',
    templateUrl: './document-expire-ccp.component.html',
    styleUrls: ['./document-expire-ccp.component.scss', '../../../../Styles/GlobalStyles.css', '../../../../Styles/FlowMGlobal.css'],
    standalone: false
})
export class DocumentExpireCCPComponent implements OnInit {

  //+================== VARIABLES CREDENTIALS ==================+\\
  private ID_User_BD: number = 0;

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';

  //+================== SEARCH ==================+\\
  public Filter_EXPIRED: string = '';

  //+================== VARIABLES GLOBAL FILES FLOW M CCP ==================+\\
  public ALL_EXPIRED_CCP: Data_Expiration_CCP[] = [];
  public Copy_ALL_EXPIRED_CCP: Data_Expiration_CCP[] = [];
  public SelectedALL_EXPIRED_CCP: Data_Expiration_CCP[] = [];

  public LoadPage: boolean = false;
  public IsExpired: boolean = false;

  //+================== VARIABLES FOR HEADERS FM ==================+\\
  public HeadersFM: Headers_CCP[] = [
    { ID: 1, Name: 'Ruta', Position: 1, Visible: true, Key_Header: 'ROU' },
    { ID: 1, Name: 'Nombre de CCP', Position: 1, Visible: true, Key_Header: 'NAM' },
    { ID: 1, Name: 'Revisión', Position: 1, Visible: true, Key_Header: 'NOR' },
    { ID: 1, Name: 'Año de modelo', Position: 1, Visible: true, Key_Header: 'MOY' },
    { ID: 1, Name: 'Código', Position: 1, Visible: true, Key_Header: 'COD' },
    { ID: 1, Name: 'Folio', Position: 1, Visible: true, Key_Header: 'INV' },
    { ID: 1, Name: 'Revisor', Position: 1, Visible: true, Key_Header: 'REV' },
    { ID: 1, Name: 'Aprobador', Position: 1, Visible: true, Key_Header: 'APP' },
    { ID: 1, Name: 'Fecha de carga', Position: 1, Visible: true, Key_Header: 'DAC' },
    { ID: 1, Name: 'Fecha de vencimiento', Position: 1, Visible: true, Key_Header: 'DAE' },
    { ID: 1, Name: 'Tiempo', Position: 1, Visible: true, Key_Header: 'TIMER' },
    { ID: 1, Name: 'Estatus ', Position: 1, Visible: true, Key_Header: 'STA' },
  ]

  //+================== FOR FILTERS ==================+\\
  public Filter_Global_Check: Filter_Check_CCP = {
    Extension: [],
    Model_Year: [],
    Status: [],
    Reviewer_Name: [],
    Approver_Name: [],
    Contributor_Name: [],
  };


  //+================== VARIABLES FOR ICONS ==================+\\
  public Icons = [
    { Icon: 'fa-user-pen', Description: 'La HOE está siendo revisada' },
    { Icon: 'fa-user-clock', Description: 'El usuario está esperando a que llegue La HOE' },
    { Icon: 'fa-user-check', Description: 'La HOE ha sido revisada y aprobada' },
    { Icon: 'fa-user-xmark', Description: 'La HOE ha sido revisada y cancelada' },
    { Icon: 'fa-user-shield', Description: 'La HOE ha sido aprobada por un administrador' },
    { Icon: 'fa-user-shield', Description: 'La HOE ha sido rechazada por un administrador' },
    { Icon: 'fa-users-slash', Description: 'No existe revisor o aprobador' },
    { Icon: 'fa-person-circle-question', Description: 'No Se tienen datos del revisor o aprobador, la HOE puede ser muy antigua' }
  ];

  //+================== VARIABLES FOR ICONS ==================+\\
  public StatusExpired = [
    { StatusExpired: 1, Description: 'El Procedimiento se encuentra con una fecha de vencimiento adecuado.' },
    { StatusExpired: 2, Description: 'El Procedimiento se encuentra próximo a vencer, le faltan 3 meses.' },
    { StatusExpired: 3, Description: 'El Procedimiento se encuentra vencido.' },
  ];

  constructor(private Service_CCP: LIBRARYCCPService, private router: Router) {
    this.ID_User_BD = Number(localStorage.getItem('ID_U_DB'));
  }

  ngOnInit(): void {
    this.Load_Component();
  }

  //&===================== FUNCTION FOR LOAD COMPONENT FLOW MONITORING CCP =====================&\\

  private async Load_Component(): Promise<void> {

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    try {

      const ResFlow_M_CCP: any = await firstValueFrom(this.Service_CCP.Procedures_Due_To_Expire_CCP());

      if (ResFlow_M_CCP.success) {
        this.ALL_EXPIRED_CCP = ResFlow_M_CCP.operation;
        this.Copy_ALL_EXPIRED_CCP = ResFlow_M_CCP.operation;
      }

      this.LoadPage = true;
      Loader.classList.remove('active');

      this.Generate_Filters();

    } catch (e) {
      Swal.fire({
        title: 'Error',
        text: '¡Error al cargar estatus HOE, recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })

      Loader.classList.remove('active');
      this.LoadPage = true;

    }


  }
  //&===================== END FUNCTION FOR LOAD COMPONENT FLOW MONITORING CCP =====================&\\



  //&===================== FUNCTIONS FOR GENERAL FLOW MONITORING CCP =====================&\\

  //-================ FUNCTION FOR MODAL HELP ================-\\
  public ToggleModalHelp(CloseOrOpen: boolean): void {
    const ModalIconsHelp = document.getElementById('ModalIconsHelp') as HTMLDivElement;
    CloseOrOpen ? ModalIconsHelp.classList.add('active') : ModalIconsHelp.classList.remove('active');
  }

  //-================ FUNCTION FOR MODAL HELP ================-\\
  public ToggleModalHelp_Expiration(CloseOrOpen: boolean): void {
    const ModalIconsHelp_Expiration = document.getElementById('ModalIconsHelp_Expiration') as HTMLDivElement;
    CloseOrOpen ? ModalIconsHelp_Expiration.classList.add('active') : ModalIconsHelp_Expiration.classList.remove('active');
  }

  //-================ FUNCTION FOR DATE FORMAT ================-\\
  public DateFormat(Date_Created: Date): string {
    return moment(Date_Created).utc().format('DD/MM/YYYY hh:mm:ss a')
  }

  //-================ FUNCTION FOR STATUS OF CCP ================-\\
  public Status_string(Status: number): string {
    switch (Status) {
      case 1: return 'Aprobada';
      case 2: return 'Pendiente';
      case 3: return 'Rechazada';
      case 4: return 'Eliminada';
      default: return '';
    }
  }

  //-================ FUNCTION FOR SEE CCP IN CCP LIBRARY FILE MANAGER ================-\\
  public SeeCCPLibrary(URL: string): void {

    const RouteEncode: string = encodeURIComponent(URL);

    this.router.navigate([`Dashboard/CCP/FMLibraryCCP/${RouteEncode}`]);
  }

  //-================ FUNCTION GREETING ================-\\
  public GetGreeting(): string {

    let TextGTings: string = '';

    const Date_User = new Date();
    const Hour = Date_User.getHours();

    if (Hour >= 0 && Hour <= 5) {
      TextGTings = 'Buenas noches';
    } else if (Hour >= 6 && Hour <= 11) {
      TextGTings = 'Buenos días';
    } else if (Hour >= 12 && Hour <= 17) {
      TextGTings = 'Buenas tardes';
    } else if (Hour >= 18) {
      TextGTings = 'Buenas noches';
    }

    return TextGTings;
  }

  //-================ FUNCTION FOR NAME USER ================-\\
  public NameUser(): string {
    const Name_User: string = localStorage.getItem('Name_User') || '';
    return (Name_User.split(' ', 2)).join(' ');
  }

  //-================ FUNCTION FOR ASSIGNED STATUS IN CCP OF DATE EXPIRED ================-\\
  public Expiry_Status(Date_Expiration: Date): string {

    const Current_Date = moment().utc();

    const Date_Difference = moment(Date_Expiration, 'YYYY/MM/DD').utc();

    const Diference = Date_Difference.diff(Current_Date, 'days');

    if (Diference >= 16) {
      return 'NotExpired'
    } else if (Diference >= 0 && Diference <= 15) {
      return 'NearingExpired'
    } else if (Diference < 0) {
      return 'Expired'
    } else {
      return 'NotExpired'
    }
  }

  public Get_Time_Remaining(Days: number): string {

    const Current_Date: Date = moment().toDate();

    return Days >= 0 ? this.Get_Time_Positive(Current_Date, Days) : this.Get_Time_Negative(Current_Date, Days);

  }

  private Get_Time_Positive(Current_Date: Date, Days: number): string {

    const Date_Add: Date = moment(Current_Date).add(Days, 'd').toDate();

    const Full_Months: number = moment(Date_Add).diff(Current_Date, 'M');

    const Date_less_Months: Date = moment(Date_Add).subtract(Full_Months, 'M').toDate();

    const Days_Remaining: number = moment(Date_less_Months).diff(Current_Date, 'd');

    return Full_Months > 0 ? `Quedan ${Full_Months} meses y ${Days_Remaining} días antes de que venza` : `Quedan ${Days_Remaining} días antes de que venza`

  }

  private Get_Time_Negative(Current_Date: Date, Days: number): string {

    Days = Days * -1;

    const Date_Add: Date = moment(Current_Date).add(Days, 'd').toDate();

    const Full_Years: number = moment(Date_Add).diff(Current_Date, 'y');
    const Date_less_Years: Date = moment(Date_Add).subtract(Full_Years, 'y').toDate();

    const Full_Months: number = moment(Date_less_Years).diff(Current_Date, 'M');
    const Date_less_Months: Date = moment(Date_less_Years).subtract(Full_Months, 'M').toDate();


    const Days_Remaining: number = moment(Date_less_Months).diff(Current_Date, 'd');

    if (Full_Years > 0) {
      return `venció hace ${Full_Years} años, ${Full_Months} meses y ${Days_Remaining} días.`
    }

    if (Full_Months > 0) {
      return `venció hace ${Full_Months} meses y ${Days_Remaining} días.`
    }

    return `venció hace ${Days_Remaining} días.`

  }

  //&===================== END FUNCTIONS FOR GENERAL FLOW MONITORING CCP =====================&\\



  //&===================== FUNCTION FOR FILTERS =====================&\\

  private Generate_Filters(): void {

    this.Filter_Global_Check = {
      Extension: [],
      Model_Year: [],
      Status: [],
      Reviewer_Name: [],
      Approver_Name: [],
      Contributor_Name: [],
    };

    for (const CCP of this.ALL_EXPIRED_CCP) {

      CCP.Date_Created = moment(CCP.Date_Created).utc().toDate();
      CCP.Date_Expiration = moment(CCP.Date_Expiration).utc().toDate();


      if (!this.Filter_Global_Check.Model_Year.includes(CCP.Model_Year) && CCP.Model_Year !== null) {
        this.Filter_Global_Check.Model_Year.push(CCP.Model_Year);
      }

      if (!this.Filter_Global_Check.Status.includes(CCP.Status) && CCP.Status !== null) {
        this.Filter_Global_Check.Status.push(CCP.Status);
      }

      if (!this.Filter_Global_Check.Reviewer_Name.includes(CCP.Reviewer_Name) && CCP.Reviewer_Name !== null) {
        this.Filter_Global_Check.Reviewer_Name.push(CCP.Reviewer_Name);
      }

      if (!this.Filter_Global_Check.Approver_Name.includes(CCP.Approver_Name) && CCP.Approver_Name !== null) {
        this.Filter_Global_Check.Approver_Name.push(CCP.Approver_Name);
      }

      if (!this.Filter_Global_Check.Contributor_Name.includes(CCP.Contributor_Name) && CCP.Contributor_Name !== null) {
        this.Filter_Global_Check.Contributor_Name.push(CCP.Contributor_Name);
      }

    }

  }

  //&===================== END FUNCTION FOR FILTERS =====================&\\
}
